export const editSmscAccount = (builder) => ({
    editSmscAccount: builder.mutation({
      query: (body) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
  
        return {
          url: '/edit_smsc',
          method: 'PUT',
          body: body,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
        };
      },
    }),
  });
  
  